import { Button, styled, Typography } from '@mui/material'

export const ListTitleText = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  maxWidth: 600,
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(1),
}))

export const ContributionImage = styled('img')(() => ({
  marginLeft: '5%',
  width: '90%',
}))

export const ContributionButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(2),
})) as typeof Button
